function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import customProperty from 'fela-plugin-custom-property';
import arrayReduce from 'fast-loops/lib/arrayReduce';

export default function pseudoPrefixer(pseudoSelector, prefixes) {
  return customProperty(_defineProperty({}, pseudoSelector, function (value) {
    return arrayReduce(prefixes, function (style, prefix) {
      style[prefix] = value;
      return style;
    }, {});
  }));
}